import { ReactNode } from 'react';
import { Auth0Provider } from '@auth0/auth0-react';
import { Auth0ProviderOptions } from '@auth0/auth0-react';

import { AuthConfigs } from '@/config';

import { AuthUserProvider } from './auth-user-provider';
import { AuthorizationBoundary } from './authorization-boundary';

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const auth0Opts: Auth0ProviderOptions = AuthConfigs;

  return (
    <Auth0Provider {...auth0Opts}>
      <AuthorizationBoundary>
        <AuthUserProvider>{children}</AuthUserProvider>
      </AuthorizationBoundary>
    </Auth0Provider>
  );
};
